<template>
  <div style="page-break-after:always;">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "page"
}
</script>

<style scoped>

</style>